import React from "react";
import LoginModal from "../modal/login_modal/LoginModal";
import { useDispatch } from "react-redux";
import {
  setChooseMode,
  setFsInfo,
  setDataLogin,
  setDetailBalance,
  setModalBalance,
  setModalLogin,
  setModalProfile,
  setOpenJackpot,
  setPromoCode,
  setShowBalance,
  setShownNewPas,
  setStartTgBot,
  setWithdrawal,
  setWithdrawalLimitation,
  setMyDepositModal,
  setMyPayoutsModal,
  setProhibitedUnconfirmed
} from "../../store/siteSlice";
import TopUpBalance from "../modal/top_up_balance/TopUpBalance";
import WithdrawalModal from "../modal/withdrawal/Withdrawal";
import PromoCodeModal from "../modal/promo_code/PromoCodeModal";
import ChooseModeGameModal from "../modal/choose_mode_game/ChooseModeGameModal";
import ShowBalance from "../modal/show_balance/ShowBalance";
import ProfileModal from "../modal/profile/ProfileModal";
import { useAppSelector } from "../../store/index.ts";
import JackpotBanner from "../landing/jackpot/jackpot_banner/JackpotBanner.jsx";
import ErrorSiteModal from "../modal/error_site_modal/ErrorSiteModal.jsx";
import ShowNewPas from "../modal/show_new_pas/ShowNewPas.jsx";
import StartTgBotModal from "../modal/start_bot_tg/StartTgBotModal.jsx";
import DetailBalance from "../modal/detail_balance/DetailBalance.jsx";
import FreeSpinInfoModal from "../modal/freespin_info/FreeSpinInfoModal.jsx";
import MyDepositModal from "../modal/my_deposit_modal/MyDepositModal.jsx";
import MyPayoutsModal from "../modal/my_payouts_modal/MyPayoutsModal.jsx";
import ProhibitedUnconfirmedEmailModal from "../modal/prohibited_unconfirmed_email/ProhibitedUnconfirmedEmailModal.jsx";

export default function CommonModals() {
  const dispatch = useDispatch();
  const openLogin = useAppSelector((state) => state.site.modals.login);
  const openBalance = useAppSelector((state) => state.site.modals.balance);
  const openWithdrawal = useAppSelector((state) => state.site.modals.withdrawal);
  const openShowBalance = useAppSelector((state) => state.site.modals.showBalance);
  const openPromoCode = useAppSelector((state) => state.site.modals.promoCode);
  const openChooseMode = useAppSelector((state) => state.site.modals.chooseMode);
  const openProfile = useAppSelector((state) => state.site.modals.profile);
  const openShownNewPas = useAppSelector((state) => state.site.modals.shownNewPas);
  const withdrawalLimitation = useAppSelector((state) => state.site.modals.withdrawalLimitation);
  const openStartTgBot = useAppSelector((state) => state.site.modals.startTgBot);
  const openDetailBalance = useAppSelector((state) => state.site.modals.detailBalance);
  const fsInfo = useAppSelector((state) => state.site.modals.fsInfo);
  const myDepositOpen = useAppSelector((state) => state.site.modals.myDeposit);
  const myPayoutsOpen = useAppSelector((state) => state.site.modals.myPayouts);
  const prohUnconf = useAppSelector((state) => state.site.modals.prohibitedUnconfirmed);
  // const openWagering = useSelector((state) => state.site.modals.bonusWagering);

  const dataChooseMode = useAppSelector((state) => state.site.modals.data.chooseMode);
  const dataLogin = useAppSelector((state) => state.site.modals.data.login);
  const bannerJackpot = useAppSelector((state) => state.site.modals.banners.jackpot);
  const isErrorSite = useAppSelector((state) => state.site.errorInfo);

  const closeLogin = () => {
    dispatch(setModalLogin(false));
    dispatch(setDataLogin({ cb: () => {} }));
  };

  const closeBalance = () => dispatch(setModalBalance(false));
  const closeWithdrawal = () => dispatch(setWithdrawal(false));
  const closePromoCode = () => dispatch(setPromoCode(false));
  const closeShowBalance = () => dispatch(setShowBalance(false));
  const closeProfile = () => dispatch(setModalProfile(false));
  const closeJackpot = () => dispatch(setOpenJackpot(false));
  // const closeErrorSite = () => dispatch(setErrorInfo(false));
  const closeShownNewPas = () => dispatch(setShownNewPas(false));
  const closeStartTgBot = () => dispatch(setStartTgBot(false));
  const closeDetailBalance = () => dispatch(setDetailBalance(false));
  const closeFsInfo = () => dispatch(setFsInfo(false));
  const closeMyDeposit = () => dispatch(setMyDepositModal(false));
  const closePayouts = () => dispatch(setMyPayoutsModal(false));
  const closeProhUnconf = () => dispatch(setProhibitedUnconfirmed(false));
  const closeWithdrawalLimitation = () => {
    dispatch(setWithdrawalLimitation(false));
    dispatch(setWithdrawal(false));
  };
  // const closeWagering = () => dispatch(setBonusWagering(false));
  const closeChooseMode = (e) => {
    dispatch(setChooseMode(false));
    dataChooseMode?.close(e);
  };

  return (
    <>
      <MyDepositModal isOpen={myDepositOpen} closeModal={closeMyDeposit} />
      <MyPayoutsModal isOpen={myPayoutsOpen} closeModal={closePayouts} />
      <FreeSpinInfoModal isOpen={!!fsInfo} campaignId={fsInfo} closeModal={closeFsInfo} />
      <WithdrawalModal isOpen={openWithdrawal} closeModal={closeWithdrawal} />
      <PromoCodeModal isOpen={openPromoCode} closeModal={closePromoCode} />
      <ChooseModeGameModal
        isOpen={openChooseMode}
        closeModal={closeChooseMode}
        data={dataChooseMode}
      />
      <ShowBalance isOpen={openShowBalance} closeModal={closeShowBalance} />
      <ProfileModal isOpen={openProfile} closeModal={closeProfile} />
      {/* <BonusWager isOpen={openWagering} closeModal={closeWagering} /> */}
      <DetailBalance isOpen={openDetailBalance} closeModal={closeDetailBalance} />
      <StartTgBotModal isOpen={openStartTgBot} closeModal={closeStartTgBot} />
      <TopUpBalance
        isOpen={!!openBalance}
        closeModal={closeBalance}
        defaultDeposit={openBalance == true ? undefined : +openBalance}
      />
      <ProhibitedUnconfirmedEmailModal
        title={"Withdrawal is limited!"}
        isOpen={withdrawalLimitation}
        closeModal={closeWithdrawalLimitation}
      />

      <ProhibitedUnconfirmedEmailModal isOpen={prohUnconf} closeModal={closeProhUnconf} />

      <ShowNewPas
        isOpen={!!openShownNewPas}
        closeModal={closeShownNewPas}
        shownNewPas={openShownNewPas}
      />

      <LoginModal isOpen={openLogin} closeModal={closeLogin} data={dataLogin} />
      <JackpotBanner jackpot={bannerJackpot} isOpen={!!bannerJackpot} closeModal={closeJackpot} />

      <ErrorSiteModal isOpen={isErrorSite} />
    </>
  );
}
